import React, { Component } from "react";
import {
  profile,
  alert,
  float,
  GET,
  PUT,
  loading,
  Status,
  required,
  Switch,
  Navbar,
  copyText,
} from "../../components/CustomComponent.js";
import QRCode from "react-qr-code";
export default class Profiles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uid: "",
      full_name: "",
      phone: "",
      password: "",
      confirm_password: "",

      current_password: "",
      broker_id: "",

      callback_url_deposit_lak: "",
callback_url_deposit_thb: "",
callback_url_withdrawal_lak: "",
callback_url_withdrawal_thb: "",
      return_url_deposit_thb: "",
      return_url_withdrawal_thb: "",
      return_url_deposit_lak: "",
      return_url_withdrawal_lak: "",

      // MISMATCH
      is_mm_bank_code: false,
      is_mm_account_number: false,
      is_mm_account_name_th: false,
      is_mm_account_name_en: false,

      tab: "account", // เมนูซ้ายเลือก account ไว้ก่อน เนื้อหาแสดงฝั่งขวา

      // 2FA
      is_2fa: false,
      email: "",
      secret: profile?.secret,
    };
  }

  async componentDidMount() {
    loading(false);
    this.Get();
  }
  Get = async () => {
    const result = await GET("v1/admin/users/profile");
    if (result?.status) {
      this.setState({
        uid: result.data?.uid || "",
        full_name: result.data?.full_name || "",
        phone: result.data?.phone || "",
        broker_id: result.data?.broker?.uid || "",
        callback_url_deposit_lak: result.data?.broker?.callback_url_deposit_lak || "",
        callback_url_deposit_thb: result.data?.broker?.callback_url_deposit_thb || "",
        callback_url_withdrawal_lak: result.data?.broker?.callback_url_withdrawal_lak || "",
        callback_url_withdrawal_thb: result.data?.broker?.callback_url_withdrawal_thb || "",
        return_url_deposit_thb: result.data?.broker?.return_url_deposit_thb || "",
        return_url_withdrawal_thb: result.data?.broker?.return_url_withdrawal_thb || "",
        return_url_deposit_lak: result.data?.broker?.return_url_deposit_lak || "",
        return_url_withdrawal_lak: result.data?.broker?.return_url_withdrawal_lak || "",
        is_mm_bank_code:
          result.data?.broker?.mismatch_check_fields?.includes("bank_code") ||
          false,
        is_mm_account_number:
          result.data?.broker?.mismatch_check_fields?.includes(
            "account_number"
          ) || false,
        is_mm_account_name_th:
          result.data?.broker?.mismatch_check_fields?.includes(
            "account_name_th"
          ) || false,
        is_mm_account_name_en:
          result.data?.broker?.mismatch_check_fields?.includes(
            "account_name_en"
          ) || false,

        is_2fa: result.data?.is_2fa || false,
        secret: result.data?.secret || false,
      });
    }
  };
  Get2FA = async () => {
    const { uid } = this.state;
    const result = await GET("v1/public/get-new-2fa", { uid: uid });
    if (result?.status) { 
      let result_update = await PUT("v1/admin/users/profile/" + uid, {
        secret: result.data,
      });
      if (result_update?.status) {
        this.Get();
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result_update?.message || "An error occurred. Please try again."
        );
      }
    }
  };
  Update2FA = async () => {
    const { uid, is_2fa } = this.state;
    let result_update = await PUT("v1/admin/users/profile/" + uid, { is_2fa });
    if (result_update?.status) {
      this.Get();
    } else {
      alert(
        "",
        "warning",
        "Warning",
        result_update?.message || "An error occurred. Please try again."
      );
    }
  };
  Update = async () => {
    const {
      uid,
      full_name,
      phone,
      password,
      confirm_password,
      current_password,
      callback_url_deposit_lak,
      callback_url_deposit_thb,
      callback_url_withdrawal_lak,
      callback_url_withdrawal_thb,
      return_url_deposit_thb,
      return_url_withdrawal_thb,
      return_url_deposit_lak,
      return_url_withdrawal_lak,
      is_mm_bank_code,
      is_mm_account_number,
      is_mm_account_name_th,
      is_mm_account_name_en,

      is_2fa,
    } = this.state;
    let mismatch_check_fields = [];
    if (!full_name.trim()) {
      alert("", "warning", "Warning", "Please input Name");
      return;
    }
    if (current_password) {
      if (!password) {
        alert("", "warning", "Warning", "Please input Password");
        return;
      } else if (!confirm_password) {
        alert("", "warning", "Warning", "Please input Confirm Password");
        return;
      } else if (password !== confirm_password) {
        alert("", "warning", "Warning", "Password not match");
        return;
      }
    }
    if (is_mm_bank_code) {
      mismatch_check_fields = [...mismatch_check_fields, "bank_code"];
    }
    if (is_mm_account_number) {
      mismatch_check_fields = [...mismatch_check_fields, "account_number"];
    }
    if (is_mm_account_name_th) {
      mismatch_check_fields = [...mismatch_check_fields, "account_name_th"];
    }
    if (is_mm_account_name_en) {
      mismatch_check_fields = [...mismatch_check_fields, "account_name_en"];
    }
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the submission?",
        "Confirm",
        "Cancel"
      )
    ) {
      loading(true);
      let body = {
        full_name,
        phone: phone || "0",
        password,
        current_password,
        callback_url_deposit_lak,
        callback_url_deposit_thb,
        callback_url_withdrawal_lak,
        callback_url_withdrawal_thb,
        return_url_deposit_thb,
        return_url_withdrawal_thb,
        return_url_deposit_lak,
        return_url_withdrawal_lak,
        mismatch_check_fields,
        is_2fa,
      };

      let result = await PUT("v1/admin/users/profile/" + uid, body);
      if (result?.status) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again."
        );
      }
      loading(false);
    }
  };
  // active = เมนูที่เลือกอยู่ (ไฮไลต์ในเมนูฝั่งซ้าย)
  renderTab = (icon, name, funcOnClick, status, active = false) => {
    return (
      <button
        className={`settings-tab d-flex justify-content-between align-items-center w-100 ${active ? "active" : ""}`}
        onClick={funcOnClick}
      >
        <div className="d-flex">
          <span className="icon me-2">{icon}</span>
          {name}
        </div>
        <div className="d-flex">
          {status}
        <span className="icon mx-3">{"\uf054"}</span>
        </div>
      </button>
    );
  };
  render() {
    const {
      full_name,
      phone,
      current_password,
      password,
      confirm_password,
      callback_url_deposit_lak,
      callback_url_deposit_thb,
      callback_url_withdrawal_lak,
      callback_url_withdrawal_thb,
      return_url_deposit_thb,
      return_url_withdrawal_thb,
      return_url_deposit_lak,
      return_url_withdrawal_lak,

      is_mm_bank_code,
      is_mm_account_number,

      is_2fa,
      secret,

      tab,
    } = this.state;
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Account</div>
                <div className="ar-title">Settings</div>
                <div className="ar-subtitle">
                  Customize your experience on Swiftgoldpay
                </div>
              </div>
            </div>
          </div>
          {/* ซ้าย = เมนู (อยู่ตลอด) · ขวา = เนื้อหาของเมนูที่เลือก */}
          <div className="row g-3 align-items-start">
            <div className="col-12 col-lg-5 col-xl-4">
                <div className="ar-table-card overflow-hidden settings-menu">
                  {this.renderTab("\uf007", "Account Infomation", () => {
                    this.setState({ tab: "account" });
                  }, null, tab === "account")}
                  {profile?.user_type === "broker" &&
                    this.renderTab("\uf0ac", "Payment Infomation", () => {
                      this.setState({ tab: "payment" });
                    }, null, tab === "payment")}
                  {this.renderTab("\uf084", "Change Password", () => {
                    this.setState({ tab: "password" });
                  }, null, tab === "password")}
                  {this.renderTab("\uf132", "2FA authentication", () => {
                    this.setState({ tab: "2FA" });
                  },is_2fa ? Status("Enabled","success"):Status("Disabled","warning"), tab === "2FA")}
                  {profile?.user_type === "broker" &&
                    this.renderTab(
                      "\uf560",
                      "Mismatch Check Configuration",
                      () => {
                        this.setState({ tab: "mismatch" });
                      },
                      null,
                      tab === "mismatch"
                    )}
                  {this.renderTab("\uf3ed", "Privacy & Policy", () => {
                    window.location.href = "/policy-privacy";
                  })}
                </div>
            </div>
            <div className="col-12 col-lg-7 col-xl-8">
              {tab !== "" && (
                <div className="ar-table-card p-3 p-md-4">
                  {tab === "account" && (
                    <div>
                      <h5 className="ar-table-title mb-3">Account Information</h5>
                      <div className="mb-3">
                        <div className="wpx-150 pr-label mt-2">Name{required}</div>
                        <input
                          type="text"
                          className="form-control pr-input"
                          placeholder="Name..."
                          onChange={(e) => {
                            this.setState({ full_name: e.target.value });
                          }}
                          value={full_name}
                        />
                      </div>
                      <div className="mb-3">
                        <div className="wpx-150 pr-label mt-2">Phone{required}</div>
                        <input
                          type="text"
                          className="form-control pr-input"
                          placeholder="Phone..."
                          maxLength={10}
                          onChange={(e) => {
                            if (!float(e.target.value)) return;
                            this.setState({ phone: e.target.value });
                          }}
                          value={phone}
                        />
                      </div>
                    </div>
                  )}
                  {tab === "payment" && profile?.user_type === "broker" && (
                    <div>
                      <h5 className="ar-table-title mb-3">Payment Information</h5>
                      
                      <div className="mb-3">
                        <div className="pr-label mt-2">Callback Deposit URL (THB)</div>
                        <input
                          type="text"
                          className="form-control pr-input"
                          placeholder="www.example.com"
                          onChange={(e) => {
                            this.setState({ callback_url_deposit_thb: e.target.value });
                          }}
                          value={callback_url_deposit_thb}
                        />
                      </div>
                      <div className="mb-3">
                        <div className="pr-label mt-2">Callback Withdrawal URL (THB)</div>
                        <input
                          type="text"
                          className="form-control pr-input"
                          placeholder="www.example.com"
                          onChange={(e) => {
                            this.setState({ callback_url_withdrawal_thb: e.target.value });
                          }}
                          value={callback_url_withdrawal_thb}
                        />
                      </div>

                      <div className="mb-3">
                        <div className="pr-label mt-2">Callback Deposit URL (LAK)</div>
                        <input
                          type="text"
                          className="form-control pr-input"
                          placeholder="www.example.com"
                          onChange={(e) => {
                            this.setState({ callback_url_deposit_lak: e.target.value });
                          }}
                          value={callback_url_deposit_lak}
                        />
                      </div>
                      <div className="mb-3">
                        <div className="pr-label mt-2">Callback Withdrawal URL (LAK)</div>
                        <input
                          type="text"
                          className="form-control pr-input"
                          placeholder="www.example.com"
                          onChange={(e) => {
                            this.setState({ callback_url_withdrawal_lak: e.target.value });
                          }}
                          value={callback_url_withdrawal_lak}
                        />
                      </div>
                      <div className="mb-3">
                        <div className="pr-label mt-2">Return Deposit URL (THB)</div>
                        <input
                          type="text"
                          className="form-control pr-input"
                          placeholder="www.example.com"
                          onChange={(e) => {
                            this.setState({ return_url_deposit_thb: e.target.value });
                          }}
                          value={return_url_deposit_thb}
                        />
                      </div>
                      <div className="mb-3">
                        <div className="pr-label mt-2">Return Withdrawal URL (THB)</div>
                        <input
                          type="text"
                          className="form-control pr-input"
                          placeholder="www.example.com"
                          onChange={(e) => {
                            this.setState({ return_url_withdrawal_thb: e.target.value });
                          }}
                          value={return_url_withdrawal_thb}
                        />
                      </div>
                      <div className="mb-3">
                        <div className="pr-label mt-2">Return Deposit URL (LAK)</div>
                        <input
                          type="text"
                          className="form-control pr-input"
                          placeholder="www.example.com"
                          onChange={(e) => {
                            this.setState({ return_url_deposit_lak: e.target.value });
                          }}
                          value={return_url_deposit_lak}
                        />
                      </div>
                      <div className="mb-3">
                        <div className="pr-label mt-2">Return Withdrawal URL (LAK)</div>
                        <input
                          type="text"
                          className="form-control pr-input"
                          placeholder="www.example.com"
                          onChange={(e) => {
                            this.setState({ return_url_withdrawal_lak: e.target.value });
                          }}
                          value={return_url_withdrawal_lak}
                        />
                      </div>
                    </div>
                  )}
                  {tab === "password" && (
                    <div>
                      <h5 className="ar-table-title mb-3">Change Password</h5>
                      <div className="mb-3">
                        <div className="wpx-150 pr-label mt-2">Current Password</div>
                        <input
                          type="password"
                          className="form-control pr-input"
                          placeholder="Current Password..."
                          onChange={(e) => {
                            this.setState({ current_password: e.target.value });
                            if (e.target.value === "") {
                              this.setState({
                                password: "",
                                confirm_password: "",
                              });
                            }
                          }}
                          value={current_password}
                        />
                      </div>
                      <div className="mb-3">
                        <div className="wpx-150 pr-label mt-2">
                          Password{current_password ? required : null}
                        </div>
                        <input
                          type="password"
                          className="form-control pr-input"
                          placeholder="Password..."
                          onChange={(e) => {
                            this.setState({ password: e.target.value });
                          }}
                          value={password}
                        />
                      </div>
                      <div className="mb-3">
                        <div className="wpx-150 pr-label mt-2">
                          Confirm Password{current_password ? required : null}
                        </div>
                        <input
                          type="password"
                          className="form-control pr-input"
                          placeholder="Confirm Password..."
                          onChange={(e) => {
                            this.setState({ confirm_password: e.target.value });
                          }}
                          value={confirm_password}
                        />
                      </div>
                    </div>
                  )}
                  {tab === "mismatch" && (
                    <div>
                      <h5 className="ar-table-title mb-3">Mismatch Check Configuration</h5>
                      <div className="mb-4 text-secondary text-12">
                        Choose which fields must match the bank. Non-matching
                        fields will show as{" "}
                        <b className="text-purple">mismatch</b>.
                      </div>
                      <div className="d-flex justify-content-between mb-3">
                        <div className="wpx-150 pr-label mt-2">Bank</div>
                        <Switch
                          onChange={(e) => {
                            this.setState({ is_mm_bank_code: e });
                          }}
                          checked={is_mm_bank_code}
                        />
                      </div>
                      <hr />
                      <div className="d-flex justify-content-between mb-3">
                        <div className="wpx-150 pr-label mt-2">Account No</div>
                        <Switch
                          onChange={(e) => {
                            this.setState({ is_mm_account_number: e });
                          }}
                          checked={is_mm_account_number}
                        />
                      </div>
                      <hr />
                      <div className="d-flex justify-content-between mb-3">
                        <div className="wpx-150 pr-label mt-2">Account Name TH</div>
                        <Switch
                          checked={true}
                          disabled
                        />
                      </div>
                      <hr />
                      <div className="d-flex justify-content-between mb-3">
                        <div className="wpx-150 pr-label mt-2">Account Name EN</div>
                        <Switch
                          checked={true}
                          disabled
                        />
                      </div>
                    </div>
                  )}
                  {tab === "2FA" && (
                    <div className="tfa">
                      <div className="d-flex align-items-start justify-content-between gap-3">
                        <div>
                          <div className="d-flex align-items-center gap-2 mb-1">
                            <h5 className="ar-table-title mb-0">Two-factor authentication</h5>
                            {is_2fa ? Status("Enabled", "success") : Status("Disabled", "warning")}
                          </div>
                          <div className="text-secondary text-12">
                            We will now ask for a login code every time you log in.
                          </div>
                        </div>
                        <Switch
                          onChange={async (e) => {
                            if (e) {
                              this.setState({ is_2fa: e });
                              setTimeout(() => {
                                this.Update2FA();
                              }, 100);
                            } else {
                              if (
                                await alert(
                                  "",
                                  "info",
                                  "Confirm",
                                  "Disabling Two-Factor Authentication (2FA) may compromise the security of your account. Please confirm if you wish to proceed.",
                                  "confirm",
                                  "cancel"
                                )
                              ) {
                                this.setState({ is_2fa: e });
                                setTimeout(() => {
                                  this.Update2FA();
                                }, 100);
                              }
                            }
                          }}
                          checked={is_2fa}
                        />
                      </div>

                      {is_2fa && (
                        <div className="tfa-steps">
                          <div className="tfa-step">
                            <span className="tfa-num">1</span>
                            <div>
                              <div className="tfa-step-title">Download an Authenticator app</div>
                              <div className="tfa-step-text">
                                We recommend downloading Authenticator if you haven't already.
                              </div>
                            </div>
                          </div>

                          <div className="tfa-step">
                            <span className="tfa-num">2</span>
                            <div className="flex-grow-1 min-w-0">
                              <div className="tfa-step-title">Scan the QR code or copy the key</div>
                              <div className="tfa-step-text">
                                Scan this QR code in the Authenticator app, or copy the key and paste it into the app.
                              </div>
                              <div className="tfa-setup">
                                <div className="tfa-qr">
                                  <QRCode
                                    size={256}
                                    style={{
                                      height: 168,
                                      width: 168,
                                    }}
                                    value={`otpauth://totp/${profile?.email}?secret=${secret}&issuer=SwiftGoldPay (${profile?.full_name})`}
                                    viewBox={`0 0 256 256`}
                                  />
                                </div>
                                <div className="tfa-key-wrap">
                                  <div className="pr-label mb-1">Setup key</div>
                                  <div className="tfa-key">{secret}</div>
                                  <div className="d-flex flex-wrap gap-2 mt-3">
                                    <button
                                      className="ar-btn-gold"
                                      onClick={() => {
                                        copyText(secret);
                                      }}
                                    >
                                      <span className="icon me-2">{"\uf0c5"}</span>
                                      Copy key
                                    </button>
                                    <button
                                      className="tfa-btn-outline"
                                      onClick={async () => {
                                        if (
                                          await alert(
                                            "",
                                            "info",
                                            "Confirm",
                                            "Confirm to reset 2FA? If you confirm, the 2FA code you connected will no longer work. You will need to reconnect.",
                                            "confirm",
                                            "cancel"
                                          )
                                        ) {
                                          this.Get2FA();
                                        }
                                      }}
                                    >
                                      <span className="icon me-2">{"\uf2f9"}</span>
                                      Reset 2FA
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="tfa-step">
                            <span className="tfa-num">3</span>
                            <div>
                              <div className="tfa-step-title">Enter the 6-digit code</div>
                              <div className="tfa-step-text">
                                After scanning the QR code or entering the key, the Authenticator app will generate a 6-digit code. Enter this code on SwiftGoldPay when you log in.
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  <div className="d-flex justify-content-end">
                    {tab !== "2FA" && (
                      <button
                        className="ar-btn-gold px-5 me-1"
                        onClick={async () => {
                          await this.Update();
                        }}
                      >
                        Submit
                      </button>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
